import React from "react";
import { SvgProps } from "./Form";

export const CollapsibleDivider = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="162"
    height="1"
    viewBox="0 0 162 1"
    fill="none"
    {...props}
  >
    <path d="M0 0.5H162" stroke="url(#paint0_linear_6020_8682)" />
    <defs>
      <linearGradient
        id="paint0_linear_6020_8682"
        x1="0"
        y1="1"
        x2="162"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" stop-opacity="0" />
        <stop offset="0.524038" stop-color="currentColor" />
        <stop offset="1" stop-color="currentColor" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
